//interfaces
import { UserActivity } from "@/interfaces/activityFeed";
import { ICommentReply } from "@/interfaces/activityFeedNotifications";

//hooks
import UseCommentReply from "./CommentReply.hooks";

//components
import { ActionFeedbackBanner } from "thrive-components";
import UserReply from "../../elements/userComment/UserReply";
import ActivityInformationPanel from "../../elements/activityInformationPanel/ActivityInformationPanel";
import DeleteComment from "../../elements/deleteComment/DeleteComment";
import DeletedBanner from "../../elements/deletedComment/DeletedComment";
import ActivityProfileData from "../../elements/activityProfileData/ActivityProfileData";
import CommentReplyTitle from "../../elements/notificationTitle/CommentReplyTitle/CommentReplyTitle";

//styling
import "../../../../../css/activityFeed/notifications/comment-reply-activity.scss";



const CommentReply = ({zIndexNum, isPopOut = false, activityId, timeStamp, dateStamp, user, meta, originalCommentText, comment, commentAuthor, content, appDetails, notificationDetails, parentList, onLikeClick, getOpenOnWebLink, onDeleteCommentClick}: ICommentReply) => {
    const { showDeleteFunctionality, showDeletedBanner, deletedBannerMessage, deletedCommentClassName, screenClassName, showFeedbackBanner, feedbackType, feedbackMessage, truncation, hideMenu, time, appName, appImage, likes, handleDeleteClick, handleLikeClick, onHideDeleteFunctionality, onDelete} = UseCommentReply({isPopOut, activityId, timeStamp, dateStamp, meta, comment, content, appDetails, notificationDetails, onLikeClick, onDeleteCommentClick})
    
    return (
        <div className={`${isPopOut ? "" : "comment-reply-notification-full"} comment-reply-notification notification-wrapper`}>
            <div className="top-row">
                <ActivityProfileData 
                    imageUrl={user.imageUrl}
                    isPopOut={isPopOut}
                    userActivity={UserActivity.comment} 
                    timeStamp={timeStamp}
                    dateStamp={dateStamp}
                />
                
                <CommentReplyTitle 
                    content={content} 
                    commentAuthor={commentAuthor?.name} 
                    user={user.name} 
                    isPopOut={isPopOut}
                />
            </div>        
            
            <UserReply
                zIndexNum={zIndexNum} 
                className={`${screenClassName} ${deletedCommentClassName}`} 
                originalText={originalCommentText ?? ""} 
                replyText={comment.text} 
                truncateNumber={truncation} 
                onLikeClick={handleLikeClick} 
                isLiked={meta.hasLiked ?? false} 
                getOpenOnWebLink={getOpenOnWebLink} 
                onDeleteCommentClick={handleDeleteClick} 
                hideMenu={hideMenu}/>

            <DeletedBanner 
                isDeleted={showDeletedBanner} 
                message={deletedBannerMessage}
            />

            {showFeedbackBanner && 
                <ActionFeedbackBanner 
                    feedbackType={feedbackType} 
                    feedbackMessage={feedbackMessage} 
                />
            }    

            <DeleteComment 
                isInlineStyle={isPopOut} 
                showModal={showDeleteFunctionality} 
                onCloseClick={onHideDeleteFunctionality} 
                onConfirmClick={onDelete} 
            />

            <ActivityInformationPanel
                className={screenClassName} 
                time={time} 
                dateStamp={dateStamp}
                appImageUrl={appImage} 
                appName={appName} 
                likes={likes} 
                likesEnabled={meta.likesEnabled} 
                contentTitle={parentList?.title} 
                contentLink={parentList?.link} 
                contentExistsInMultiplePlaces={content.existsInMultiplePlaces}
            /> 
        </div>
    )
};

export default CommentReply